import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Camraderie Parade',
  date: new Date(2023, 6, 9),
  img: '/img/squirrel.jpeg',
  tracks: [
    {
      title: 'Insatiable Appetite',
      src: '/songs/2023-07-09/insatiable_appetite.mp3',
    },
    {
      title: 'Giving due Credit',
      src: '/songs/2023-07-09/giving_due_credit.mp3',
    },
    {
      title: 'Fight of Flight',
      src: '/songs/2023-07-09/fight_or_flight.mp3',
    },
    {
      title: 'Setting the Record Straight',
      src: '/songs/2023-07-09/setting_the_record_straight.mp3',
    },
    {
      title: 'Your Space',
      src: '/songs/2023-07-09/your_space.mp3',
    },
    {
      title: 'Mountain Lion',
      src: '/songs/2023-07-09/mountain_lion.mp3',
    },
    {
      title: 'Train to Catch',
      src: '/songs/2023-07-09/train_to_catch.mp3',
    },
    {
      title: 'Squirrel Nuts',
      src: '/songs/2023-07-09/squirrel_nuts.mp3',
    },
    {
      title: 'Driftwood',
      src: '/songs/2023-07-09/driftwood.mp3',
    },
  ]
}
export default album;